import { useState } from "preact/hooks";
import { formatSsmValue } from "../../utils/renderSsmValue";

const PREVIEW_THRESHOLD = 120;

export function SsmValueCell({ type, value }: { type: string; value: string }) {
  const [expanded, setExpanded] = useState(false);
  const content = formatSsmValue(type, value);

  if (value.length <= PREVIEW_THRESHOLD) {
    return <>{content}</>;
  }

  return (
    <>
      <button type="button" class="ssm-value-preview" onClick={() => setExpanded(true)}>
        {value.slice(0, PREVIEW_THRESHOLD)}…
      </button>
      {expanded && (
        <div class="ssm-value-modal-backdrop" onClick={() => setExpanded(false)}>
          <div class="ssm-value-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" class="ssm-value-modal-close" onClick={() => setExpanded(false)}>
              ✕
            </button>
            <div class="ssm-value-modal-content">{content}</div>
          </div>
        </div>
      )}
    </>
  );
}
